/**
 * Routes for Authentication Feature Group
 *
 * @private
 */
export enum AuthenticationRouteId {
    Login = "LOGIN",
    Logout = "LOGOUT",
    AcceptInvitation = "ACCEPT_INVITATION",
    ForgotPassword = "FORGOT_PASSWORD",
    ForgotPasswordRequest = "FORGOT_PASSWORD_REQUEST"
}
